__webpack_require__.p = "/usa/en/product-areas/vascular-access/central-access/power-of-chlorhexidine/";